/**
 * PDP Size Selector
 * Syncs size dropdown selection to hidden form input
 * Shows alert message only when user tries to submit without selecting a size
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get all size selectors on the page (desktop + mobile)
  const sizeSelectors = document.querySelectorAll('[data-size-selector]');
  const sizeAlerts = document.querySelectorAll('[data-size-alert]');
  const submitButtons = document.querySelectorAll('.product-form__cart-submit');
  
  // Function to check if size is selected
  function hasSizeSelected() {
    return Array.from(sizeSelectors).some(selector => selector.value !== '');
  }
  
  // Function to hide alert
  function hideAlert() {
    sizeAlerts.forEach(function(alert) {
      alert.style.display = 'none';
    });
  }
  
  // Function to show alert
  function showAlert() {
    sizeAlerts.forEach(function(alert) {
      alert.style.display = 'block';
    });
  }
  
  // Add click listeners to submit buttons to show alert and prevent submission when clicked without size
  submitButtons.forEach(function(button) {
    // Remove disabled attribute so button is clickable
    button.removeAttribute('disabled');
    
    button.addEventListener('click', function(e) {
      // Only block submission if size selectors exist AND no size is selected
      if (sizeSelectors.length > 0 && !hasSizeSelected()) {
        e.preventDefault();
        e.stopPropagation();
        showAlert();
        return false;
      }
      // If no size selectors exist or size is selected, allow normal submission
    });
  });
  
  sizeSelectors.forEach(function(sizeSelector) {
    // Listen for changes on the size dropdown
    sizeSelector.addEventListener('change', function() {
      const selectedSize = this.value;
      
      // Find all size input fields (desktop + mobile forms)
      const sizeInputs = document.querySelectorAll('[data-size-input]');
      
      // Update all hidden size inputs with the selected value
      sizeInputs.forEach(function(input) {
        input.value = selectedSize;
      });
      
      // Hide alert when size is selected
      hideAlert();
    });
  });
  
  // Sync initial state if there's a pre-selected size
  sizeSelectors.forEach(function(sizeSelector) {
    if (sizeSelector.value) {
      const event = new Event('change');
      sizeSelector.dispatchEvent(event);
    }
  });
});